import { ReduxAction } from "../../types";
import * as Nested from "../../util/Nested";
import LocationsForm from "./LocationsForm";

interface State {}

const initialState: State = {};

export const LOCATIONS_FORM_ACTION = "posConfigTool/LOCATIONS_FORM_ACTION";
export const locationsFormAction = Nested.nestedAction(LOCATIONS_FORM_ACTION);

const _reducer = (state: State = initialState, { type }: ReduxAction): State => {
  switch (type) {
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = () => {};
export const _mapDispatchToProps = () => {};

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      locationsForm: {
        ...LocationsForm,
        actionType: LOCATIONS_FORM_ACTION,
      },
    },
  },
  "locations"
);

// Nested Reducer
const reducer = (state: State, action: ReduxAction) => nestedReducer(state, action);
export { reducer, mapStateToProps, mapDispatchToProps };
